<div class="campanha-roi-chart-table table-responsive">
    <table class="table table-striped table-bordered table-hover">
        <thead>
            <tr>
                <th class="col-entity" *ngIf="isVisualizacaoCampanhas">Campanha</th>
                <th class="col-entity" *ngIf="isVisualizacaoPacotes">Pacote</th>

                <th class="col-status text-center" *ngIf="isVisualizacaoCampanhas">Status</th>
                <th class="col-valor-recursos text-right">Recursos</th>
                <th class="col-valor-vendas text-right">Resultado</th>
                <th class="col-roi text-right">ROI</th>
            </tr>
        </thead>

        <tbody *ngIf="isLoading">
            <tr>
                <td class="text-center" colspan="5">
                    <i class='fas fa-spinner fa-pulse'></i> Carregando
                </td>
            </tr>
        </tbody>

        <tbody *ngIf="isEmpty">
            <tr>
                <td class="text-center" colspan="5">
                    <i class="fas fa-info" aria-hidden="true"></i>
                    <span *ngIf="isVisualizacaoCampanhas">
                        Nenhuma campanha encontrada
                    </span>
                    <span *ngIf="isVisualizacaoPacotes">
                        Nenhum pacote encontrado
                    </span>                    
                </td>
            </tr>                  
        </tbody>            

        <ng-template [ngIf]="chart">
            <tbody>
                <tr *ngFor="let campanha of chart.entities">
                    <td class="col-entity">
                        {{campanha.nome}}
                    </td>
                    <td class="col-status text-center" *ngIf="isVisualizacaoCampanhas">
                        <sgt-campanha-status-badge
                            [status]="campanha.status">
                        </sgt-campanha-status-badge>
                    </td>                                
                    <td class="col-valor-recursos text-right">
                        {{campanha.roi?.valorTotalDespesas | currencyFormat: 1:2:2}}
                    </td>
                    <td class="col-valor-vendas text-right">
                        {{campanha.roi?.valorTotalVendas | currencyFormat: 1:2:2}}
                    </td>
                    <td class="col-roi text-right"
                        [class.roi-negativo]="campanha.roi?.retornoEfetivo < 0"
                        [class.roi-positivo]="campanha.roi?.retornoEfetivo > 0">

                        {{campanha.roi?.retornoEfetivo | decimalFormat: 1:2:2}}x

                        <!-- <ng-template [ngIf]="campanha.roi?.retornoEfetivo == 0">
                            {{campanha.roi?.retornoEfetivo | decimalFormat: 1:2:2}}
                        </ng-template>

                        <ng-template [ngIf]="campanha.roi?.retornoEfetivo !== 0">
                            <div class="progress-container">
                                <div class="progress progress-roi-nevativo flex-row-reverse">
                                    <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="campanha.roi?.retornoEfetivo" aria-valuemin="0" aria-valuemax="100"
                                        [style.width]="campanha.roi?.retornoEfetivo + '%'">
                                        {{campanha.roi?.retornoEfetivo | decimalFormat: 1:2:2}}
                                    </div>
                                </div>
        
                                <div class="progress progress-roi-positivo">
                                    <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="campanha.roi?.retornoEfetivo" aria-valuemin="0" aria-valuemax="100"
                                        [style.width]="campanha.roi?.retornoEfetivo + '%'">
                                        {{campanha.roi?.retornoEfetivo | decimalFormat: 1:2:2}}
                                    </div>
                                </div>                        
                            </div>
                        </ng-template> -->
                    </td>                                                                        
                </tr>              
            </tbody>

            <tfoot>
                <tr>
                    <td class="col-entity" colspan="2" *ngIf="isVisualizacaoCampanhas">
                        {{chart.quantidadeEntities}} {{chart.quantidadeEntities | campanhaCountLabel}}
                    </td>
                    <td class="col-entity" *ngIf="isVisualizacaoPacotes">
                        {{chart.quantidadeEntities}} {{chart.quantidadeEntities | pacoteCampanhaCountLabel}}
                    </td>                    

                    <td class="col-valor-recursos text-right">
                        {{chart.roi?.valorTotalDespesas | currencyFormat: 1:2:2}}
                    </td>
                    <td class="col-valor-vendas text-right">
                        {{chart.roi?.valorTotalVendas | currencyFormat: 1:2:2}}
                    </td>
                    <td class="col-roi text-right"
                        [class.roi-negativo]="chart.roi?.retornoEfetivo < 0"
                        [class.roi-positivo]="chart.roi?.retornoEfetivo > 0">
                        {{chart.roi?.retornoEfetivo | decimalFormat: 1:2:2}}x
                    </td>
                </tr>
            </tfoot>
        </ng-template>
    </table>
</div>